import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { layoutRoutes } from './layout/layout-routes';
import { authRoutes } from './auth/auth-routes';
import { appGuard } from './auth/guards/app.guard';

export const routes: Routes = [
  ...authRoutes,
  {
    path: 'new-password/:token',
    loadComponent: () =>
      import('./pages/new-password/new-password.component')
        .then((m) => m.NewPasswordComponent),
  },
  {
    path: '',
    canActivate: [appGuard],
    component: LayoutComponent,
    children: [
      ...layoutRoutes,
      {
        path: '**',
        loadComponent: () =>
          import('./pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
      },
    ],
  },
];
